import "./IconButton.css";
import React from "react";
import classNames from "classnames";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type Props = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: "submit" | "reset" | "button";
  className?: string;
  children?: React.ReactNode;
  tooltip?: string;
  disabled?: boolean;
};

export default function IconButton({
  disabled,
  type,
  onClick,
  className,
  children,
  tooltip,
}: Props) {
  return tooltip ? (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={`tooltip-${tooltip}`}>{tooltip}</Tooltip>}
    >
      <button
        onClick={onClick}
        type={type}
        disabled={disabled}
        title={tooltip}
        aria-label={tooltip}
        className={classNames(["icon-button", className])}
      >
        {children}
      </button>
    </OverlayTrigger>
  ) : (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled}
      className={classNames(["icon-button", className])}
    >
      {children}
    </button>
  );
}
